import { useListingContext } from '@/context/listing';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TotalsAndReset = ({ count, hasFiltersApplied }) => {
  const { t } = useTranslation();
  const [, { clearFilters }] = useListingContext();

  if (count <= 0) return null;

  return (
    <div className='--totals-and-reset'>
      <span className='--total'>
        {t(
          `listing:listing.plus.filters.totals.${count <= 1 ? 'one' : 'other'}`,
          { count },
        )}
      </span>
      {hasFiltersApplied && (
        <button type='button' className='--reset' onClick={clearFilters}>
          {t('listing:listing.plus.filters.clear.all.label')}
        </button>
      )}
    </div>
  );
};

TotalsAndReset.propTypes = {
  count: PropTypes.number,
  hasFiltersApplied: PropTypes.bool,
};

TotalsAndReset.defaultProps = {
  count: 0,
  hasFiltersApplied: false,
};

export default TotalsAndReset;
